import { SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, type BrowserOptions } from '@sentry/react';

type TracesSampler = NonNullable<BrowserOptions['tracesSampler']>;
type TracesSamplingContext = Parameters<TracesSampler>[0];

/*
 * Sample rates for spans whose origin needs its own rate. Keys are the `sentry.origin`
 * values set by Sentry integrations (`sentry.op` only reaches the sampler from SDK v11).
 * Page loads are the largest and most frequent transactions, so they get the lowest rate.
 */
const SAMPLE_RATE_BY_SPAN_ORIGIN: Readonly<Partial<Record<string, number>>> = {
  'auto.pageload.browser': 0.05,
};

const DEFAULT_SAMPLE_RATE = {
  stable: 0.1,
  nonStable: 0.2,
} as const satisfies Record<string, number>;

export function createTracesSampler(environment: string): TracesSampler {
  const defaultRate: number = environment === 'stable' ? DEFAULT_SAMPLE_RATE.stable : DEFAULT_SAMPLE_RATE.nonStable;

  return ({ attributes }: TracesSamplingContext): number => {
    const spanOrigin: unknown = attributes?.[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    const originRate: number | undefined =
      typeof spanOrigin === 'string' ? SAMPLE_RATE_BY_SPAN_ORIGIN[spanOrigin] : undefined;

    return originRate ?? defaultRate;
  };
}
